module.exports = __webpack_public_path__ + "static/ProfessionalsCarousel2-cc1424b802d540e62a8726a108b93b30.jpg";